import React, { useState } from "react";

/**
 * Plain DataGrid column header label with the same native browser hover
 * tooltip used by FilterHeaderDropdown (not MUI Tooltip).
 */
const ColumnHeaderLabel = ({ label }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <span
      title={isHovered ? label : undefined}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        display: "block",
        width: "100%",
        maxWidth: "100%",
        fontSize: "0.75rem",
        fontWeight: 600,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
};

export default ColumnHeaderLabel;
